import { RiskLevel } from 'shared/enum/bio-report.enum';
import { IBioReportRetail, IDashboardReportRetail } from 'shared/interface/bio-report-retail.interface';
import api from 'shared/service/api';

const url = 'admin-dashboard-report-retail';

export default class AdminDashboardRetailService {
    static async findAll(
        from: Date,
        to: Date,
        owningCompanies?: string[],
        owningUsers?: string[]
    ): Promise<IDashboardReportRetail> {
        const params = {};
        if (owningCompanies && owningCompanies.length) {
            params['owningCompanies'] = owningCompanies;
        }
        if (owningUsers && owningUsers.length) {
            params['owningUsers'] = owningUsers;
        }
        const response = await api.get(url, {
            params: {
                from: from.toISOString(),
                to: to.toISOString(),
                ...params,
            },
        });
        return response.data;
    }

    static async findWithAnalytic(
        from: Date,
        to: Date,
        owningCompanies?: string[],
        owningUsers?: string[],
        questionId?: string,
        answer?: number,
        riskLevel?: RiskLevel,
        position?: number,
    ): Promise<IBioReportRetail[]> {
        const params = {};
        if (owningCompanies && owningCompanies.length) {
            params['owningCompanies'] = owningCompanies;
        }
        if (owningUsers && owningUsers.length) {
            params['owningUsers'] = owningUsers;
        }
        if (questionId && answer !== undefined) {
            params['questionId'] = questionId;
            params['answer'] = answer;
        }
        if (riskLevel && position) {
            params['riskLevel'] = riskLevel;
            params['position'] = position;
        }
        const response = await api.get(`${url}/with-analytic`, {
            params: {
                from: from.toISOString(),
                to: to.toISOString(),
                ...params,
            },
        });
        return response.data;
    }

    static async getExcel(
        from: Date,
        to: Date,
        owningCompanies?: string[],
        owningUsers?: string[]
    ) {
        const params = {};
        if (owningCompanies && owningCompanies.length) {
            params['owningCompanies'] = owningCompanies;
        }
        if (owningUsers && owningUsers.length) {
            params['owningUsers'] = owningUsers;
        }
        const response = await api.get(`${url}/excel`, {
            params: {
                from: from.toISOString(),
                to: to.toISOString(),
                ...params,
            },
            responseType: 'blob',
        });
        return response.data;
    }
}
